(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-product-page"]) return;
  try {
    
  (function () {
    var atcBtn   = document.getElementById('bundle-atc-btn');
    var buyBtn   = document.getElementById('bundle-buy-btn');
    var qtyInput = document.getElementById('bundle-qty');

    /* ── Gallery thumbnails — swap the main image. Opening the lightbox is
       handled separately by snippets/image-lightbox.liquid via the
       data-lightbox-* hooks. Wired before the atcBtn guard so the gallery
       works regardless of purchase-button state. ── */
    var bppMainWrap = document.querySelector('.bundle-product-page__main-image-wrap');
    var bppMainImg  = bppMainWrap ? bppMainWrap.querySelector('img') : null;
    var bppThumbs   = document.querySelectorAll('.bundle-product-page__thumb');
    bppThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (bppMainImg) {
          bppMainImg.removeAttribute('srcset');
          bppMainImg.removeAttribute('sizes');
          bppMainImg.src = thumb.dataset.imageUrl;
          bppMainImg.alt = thumb.dataset.imageAlt;
        }
        bppThumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    if (!atcBtn) return;

    /* ── Qty max: min(50, inventory) when tracking enabled (shared via window.Pushmax).
       window.Pushmax lives in the SNIPPET bundle, which Shopify loads AFTER this
       SECTION bundle — a synchronous call here would throw and kill the whole
       section script. Defer to DOMContentLoaded (after both bundles run) and
       guard against a missing Pushmax. ── */
    var purchaseEl = document.querySelector('.bundle-product-page__purchase');
    function bppInitQtyMax() {
      if (!qtyInput || !purchaseEl || !window.Pushmax) return;
      window.Pushmax.applyQtyMax(qtyInput, window.Pushmax.getMaxQty(
        purchaseEl.dataset.inventoryManagement || '',
        purchaseEl.dataset.inventoryPolicy    || '',
        parseInt(purchaseEl.dataset.inventoryQuantity, 10) || 0
      ));
    }
    if (window.Pushmax) {
      bppInitQtyMax();
    } else {
      document.addEventListener('DOMContentLoaded', bppInitQtyMax);
    }

    /* Sub-component text elements */
    var atcTextEl = atcBtn.querySelector('.ui-atc-btn__text');
    var buyTextEl = buyBtn ? buyBtn.querySelector('.ui-buy-btn__text') : null;

    /* Original labels from data attributes (set by sub-component snippets) */
    var atcOriginalLabel = atcBtn.dataset.label || 'Add to Cart';
    var buyOriginalLabel = buyBtn ? (buyBtn.dataset.label || 'Buy Now') : 'Buy Now';

    /* Translated UI strings (set on .bundle-product-page__purchase by this section's Liquid) */
    var labelAdded      = purchaseEl ? (purchaseEl.dataset.labelAdded      || 'Added')              : 'Added';
    var labelError       = purchaseEl ? (purchaseEl.dataset.labelError     || 'Error — try again')  : 'Error — try again';
    var labelProcessing  = purchaseEl ? (purchaseEl.dataset.labelProcessing|| 'Processing...')       : 'Processing...';
    var labelSoldOut     = purchaseEl ? (purchaseEl.dataset.labelSoldOut   || 'Sold out')            : 'Sold out';

    /* ── Flavor selection — the bundle product's OWN real variants/options,
       resolved the same way as sections/product.liquid. Selecting a chip here
       recomputes the actual purchasable variant, so the correct per-component
       inventory is what Shopify's Bundles Function deducts from. ── */
    var variants = null;
    var selectedOptions = {}; /* keyed by option index (0-based) */

    var optionsEl = document.querySelector('.bundle-product-page__flavor-data');
    if (optionsEl && optionsEl.dataset.variants) {
      variants = JSON.parse(optionsEl.dataset.variants);
      optionsEl.querySelectorAll('.ui-chips__chip--active').forEach(function (chip) {
        selectedOptions[chip.dataset.optionIndex] = chip.dataset.chipValue;
      });
    }

    function updateVariant() {
      if (!variants) return;

      var indices = Object.keys(selectedOptions).sort();
      var matched = null;

      for (var i = 0; i < variants.length; i++) {
        var v    = variants[i];
        var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null; });
        var match = indices.every(function (idx) {
          return opts[parseInt(idx, 10)] === selectedOptions[idx];
        });
        if (match) { matched = v; break; }
      }

      if (!matched) return;

      /* Price */
      var priceEl = document.querySelector('.bundle-product-page__price');
      if (priceEl) priceEl.textContent = window.Pushmax ? window.Pushmax.formatMoney(matched.price) : ('$' + (matched.price / 100).toFixed(2));

      /* ATC / Buy Now buttons */
      atcBtn.dataset.variantId = matched.id;
      if (buyBtn) buyBtn.dataset.variantId = matched.id;
      if (matched.available) {
        atcBtn.disabled = false;
        atcBtn.classList.remove('ui-atc-btn--soldout');
        if (atcTextEl) atcTextEl.textContent = atcOriginalLabel;
        if (buyBtn) {
          buyBtn.disabled = false;
          if (buyTextEl) buyTextEl.textContent = buyOriginalLabel;
        }
      } else {
        atcBtn.disabled = true;
        atcBtn.classList.add('ui-atc-btn--soldout');
        if (atcTextEl) atcTextEl.textContent = labelSoldOut;
        if (buyBtn) {
          buyBtn.disabled = true;
          if (buyTextEl) buyTextEl.textContent = labelSoldOut;
        }
      }

      /* Qty max — inventory-aware, capped at 50 */
      if (qtyInput && window.Pushmax) {
        window.Pushmax.applyQtyMax(qtyInput, window.Pushmax.getMaxQty(
          matched.inventory_management || '',
          matched.inventory_policy    || '',
          matched.inventory_quantity  || 0
        ));
      }

      /* Main image swap — clear srcset/sizes first, same fix as sections/product.liquid */
      if (matched.featured_image && matched.featured_image.src && bppMainImg) {
        bppMainImg.removeAttribute('srcset');
        bppMainImg.removeAttribute('sizes');
        bppMainImg.src = matched.featured_image.src;
        bppMainImg.alt = matched.featured_image.alt || bppMainImg.alt;
      }
    }

    if (optionsEl) {
      optionsEl.addEventListener('click', function (e) {
        var chip = e.target.closest('.ui-chips__chip');
        if (!chip || chip.classList.contains('ui-chips__chip--unavailable')) return;

        var optionIndex = chip.dataset.optionIndex;
        var chipValue   = chip.dataset.chipValue;

        chip.closest('.ui-chips__row').querySelectorAll('.ui-chips__chip').forEach(function (c) {
          var isActive = c.dataset.chipValue === chipValue;
          c.classList.toggle('ui-chips__chip--active', isActive);
          c.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        var chipWrapper = chip.closest('.ui-chips');
        if (chipWrapper) {
          var selectedValEl = chipWrapper.querySelector('.ui-chips__selected-val');
          if (selectedValEl) selectedValEl.textContent = ': ' + chipValue;
        }

        /* Swap this component's thumbnail to the selected flavor's native
           variant image. Match by option-value name first, then by position
           (handles bundle-vs-component flavor-name drift) — mirrors the
           quick-add drawer in sections/bundle-quick-add.liquid. */
        var compRow = chip.closest('.bundle-component');
        if (compRow) {
          var imgByName = null, imgByIndex = null;
          try { imgByName = JSON.parse(compRow.dataset.componentImages || 'null'); } catch (e1) {}
          try { imgByIndex = JSON.parse(compRow.dataset.componentImagesIndex || 'null'); } catch (e2) {}
          var newSrc = imgByName ? imgByName[chipValue] : null;
          if (!newSrc && imgByIndex) {
            var chipRow = chip.closest('.ui-chips__row');
            if (chipRow) {
              var rowChips = chipRow.querySelectorAll('.ui-chips__chip');
              var vi = Array.prototype.indexOf.call(rowChips, chip);
              if (vi >= 0 && vi < imgByIndex.length) newSrc = imgByIndex[vi];
            }
          }
          if (newSrc) {
            var compImg = compRow.querySelector('.bundle-component__media img');
            if (compImg) {
              compImg.removeAttribute('srcset');
              compImg.removeAttribute('sizes');
              compImg.src = newSrc;
            }
          }
        }

        selectedOptions[optionIndex] = chipValue;
        updateVariant();
      });
    }

    /* Note: ui-quantity-input snippet owns the +/- button click logic for #bundle-qty.
       We only need to read qtyInput.value when adding to cart. */

    /* ── Shared add-to-cart — delegates to window.addToCart (global-header.liquid) ── */
    function addToCart(triggerBtn, onSuccess) {
      var variantId = parseInt(atcBtn.dataset.variantId, 10);
      var qty       = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var isATC     = triggerBtn.id === 'bundle-atc-btn';
      var textEl    = isATC ? atcTextEl : buyTextEl;
      var origLabel = isATC ? atcOriginalLabel : buyOriginalLabel;

      /* Loading state */
      if (isATC) {
        atcBtn.classList.add('ui-atc-btn--loading');
      } else {
        if (textEl) textEl.textContent = labelProcessing;
      }
      triggerBtn.disabled = true;

      window.addToCart(
        variantId,
        function () {
          /* Success — cart count refreshed by window.addToCart */

          /* Buy Now: redirect to checkout */
          if (onSuccess) { onSuccess(); return; }

          /* ATC success: brief confirmation then reset */
          atcBtn.classList.remove('ui-atc-btn--loading');
          atcBtn.classList.add('ui-atc-btn--added');
          if (atcTextEl) atcTextEl.textContent = labelAdded;
          if (window.openCartDrawer) window.openCartDrawer();
          setTimeout(function () {
            atcBtn.classList.remove('ui-atc-btn--added');
            if (atcTextEl) atcTextEl.textContent = atcOriginalLabel;
            if (!atcBtn.classList.contains('ui-atc-btn--soldout')) atcBtn.disabled = false;
          }, 1200);
        },
        function () {
          /* Error */
          if (isATC) atcBtn.classList.remove('ui-atc-btn--loading');
          triggerBtn.disabled = false;
          if (textEl) {
            textEl.textContent = labelError;
            setTimeout(function () { textEl.textContent = origLabel; }, 2000);
          }
        },
        qty
      );
    }

    /* ── ATC click ── */
    atcBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (atcBtn.disabled) return;
      addToCart(atcBtn, null);
    });

    /* ── Buy Now click ── */
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        if (buyBtn.disabled) return;
        addToCart(buyBtn, function () {
          window.location.href = '/checkout';
        });
      });
    }

    /* ── bfcache reset (browser back from checkout) ── */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      if (buyBtn && buyTextEl) buyTextEl.textContent = buyOriginalLabel;
      if (buyBtn) buyBtn.disabled = false;
      atcBtn.classList.remove('ui-atc-btn--loading', 'ui-atc-btn--added');
      atcBtn.disabled = false;
      if (atcTextEl) atcTextEl.textContent = atcOriginalLabel;
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-quick-add"]) return;
  try {
    
  (function () {
    var backdrop = document.getElementById('bqa-backdrop');
    var drawer   = document.getElementById('bqa-drawer');
    var bodyEl   = document.getElementById('bqa-body');
    var titleEl  = document.getElementById('bqa-title');
    var priceEl  = document.getElementById('bqa-price');
    var mediaEl  = document.getElementById('bqa-header-media');
    var closeBtn = document.getElementById('bqa-close');
    var qtyInput = document.getElementById('bqa-qty');
    var atcBtn   = document.getElementById('bqa-atc');
    var buyBtn   = document.getElementById('bqa-buy');

    if (!drawer) return;

    /* ── Flavor selection state — the bundle product's OWN real variants/
       options (see FLAVOR_AND_VARIANT_MEDIA.md and git history). Rebuilt on
       every open from the trigger button's data-bundle-variants /
       data-bundle-options attributes (snippets/bundle-card.liquid). ── */
    var currentVariantId = null;
    var bundleVariants   = [];
    var bundleOptions    = [];
    var swatchMap        = {};
    var selectedOptions  = {}; /* keyed by option index (0-based) */

    var _bqaLastFocus      = null;
    var labelAdded         = drawer.dataset.labelAdded || 'Added';
    var labelAddedAnnounce = drawer.dataset.labelAddedAnnouncement || 'Bundle added to cart';
    var labelError         = drawer.dataset.labelError || 'Error — try again';
    var labelProcessing    = drawer.dataset.labelProcessing || 'Processing…';
    var labelSoldOut       = drawer.dataset.labelSoldOut || 'Sold out';

    var atcOriginalLabel = atcBtn ? (atcBtn.dataset.label || 'Add to Cart') : 'Add to Cart';
    var buyOriginalLabel = buyBtn ? (buyBtn.dataset.label || 'Buy Now')     : 'Buy Now';

    /* ── Money formatter — shared via window.Pushmax (now respects shop money format) ── */
    function formatMoney(cents) {
      return window.Pushmax.formatMoney(cents);
    }

    /* ── Open / close ── */
    function openDrawer() {
      if (!backdrop || !drawer) return;
      _bqaLastFocus = document.activeElement;
      backdrop.removeAttribute('aria-hidden');
      drawer.removeAttribute('aria-hidden');
      backdrop.classList.add('is-open');
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (window.trapFocus) window.trapFocus(drawer); }, 50);
    }

    function closeDrawer() {
      if (!backdrop || !drawer) return;
      if (window.releaseFocus) window.releaseFocus(drawer);
      backdrop.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('aria-hidden', 'true');
      backdrop.classList.remove('is-open');
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      if (_bqaLastFocus) { _bqaLastFocus.focus(); _bqaLastFocus = null; }
    }

    /* ── Button state helpers ── */
    function resetAtcBtn() {
      if (!atcBtn) return;
      atcBtn.classList.remove('ui-atc-btn--loading', 'ui-atc-btn--added');
      atcBtn.disabled = false;
      var t = atcBtn.querySelector('.ui-atc-btn__text');
      if (t) t.textContent = atcOriginalLabel;
    }

    function resetBuyBtn() {
      if (!buyBtn) return;
      buyBtn.classList.remove('ui-buy-btn--loading');
      buyBtn.disabled = false;
      var t = buyBtn.querySelector('.ui-buy-btn__text');
      if (t) t.textContent = buyOriginalLabel;
    }

    function resetQty() {
      if (!qtyInput) return;
      qtyInput.value = 1;
      var wrap   = qtyInput.closest('.ui-qty');
      var decBtn = wrap ? wrap.querySelector('[data-qty-dec]') : null;
      var incBtn = wrap ? wrap.querySelector('[data-qty-inc]') : null;
      if (decBtn) decBtn.disabled = true;
      if (incBtn) incBtn.disabled = false;
    }

    /* ── Build one .ui-chips block for a single bundle option. Shared by the
       inline-per-component placement and the general leftover block below —
       same chip markup either way, just a different mount point and whether
       the redundant option-name label is shown. ── */
    function buildOptionChips(opt, optionIndex, seedVariant, hideLabel) {
      var seedValue = seedVariant
        ? [seedVariant.option1, seedVariant.option2, seedVariant.option3][optionIndex]
        : opt.values[0];
      selectedOptions[optionIndex] = seedValue;

      var wrapper = document.createElement('div');
      wrapper.className = 'ui-chips';

      if (!hideLabel) {
        var label = document.createElement('p');
        label.className = 'ui-chips__label';
        label.textContent = opt.name;
        var valueSpan = document.createElement('span');
        valueSpan.className = 'ui-chips__selected-val';
        valueSpan.textContent = ': ' + seedValue;
        label.appendChild(valueSpan);
        wrapper.appendChild(label);
      }

      var row = document.createElement('div');
      row.className = 'ui-chips__row';
      row.dataset.optionIndex = String(optionIndex);
      row.setAttribute('role', 'group');
      row.setAttribute('aria-label', opt.name);

      opt.values.forEach(function (val, valIndex) {
        var hasAvailable = bundleVariants.some(function (v) {
          return [v.option1, v.option2, v.option3][optionIndex] === val && v.available;
        });

        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'ui-chips__chip'
          + (val === seedValue ? ' ui-chips__chip--active' : '')
          + (!hasAvailable ? ' ui-chips__chip--unavailable' : '');
        chip.dataset.optionIndex = String(optionIndex);
        chip.dataset.valueIndex  = String(valIndex);
        chip.dataset.chipValue   = val;
        chip.textContent         = val;
        chip.setAttribute('aria-pressed', val === seedValue ? 'true' : 'false');
        if (!hasAvailable) {
          chip.disabled = true;
          chip.setAttribute('aria-disabled', 'true');
        }
        if (swatchMap[val]) {
          chip.style.setProperty('--chip-swatch', swatchMap[val].color);
          chip.style.setProperty('--chip-swatch-text', swatchMap[val].text);
        }
        row.appendChild(chip);
      });

      wrapper.appendChild(row);
      return wrapper;
    }

    /* ── Build a single, non-interactive chip showing a fixed flavor value —
       for a component with only one flavor (nothing to choose), which
       Shopify doesn't give its own bundle-level selector. Mirrors
       snippets/ui-flavor-badge.liquid so it looks identical to the PDP. ── */
    function buildFixedFlavorBadge(fixedFlavor) {
      var wrapper = document.createElement('div');
      wrapper.className = 'ui-chips ui-chips--fixed';

      var row = document.createElement('div');
      row.className = 'ui-chips__row';
      row.setAttribute('role', 'group');
      row.setAttribute('aria-label', fixedFlavor.name || fixedFlavor.value);

      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'ui-chips__chip ui-chips__chip--active ui-chips__chip--fixed';
      chip.disabled = true;
      chip.setAttribute('aria-disabled', 'true');
      chip.textContent = fixedFlavor.value;
      if (fixedFlavor.color) {
        chip.style.setProperty('--chip-swatch', fixedFlavor.color);
        chip.style.setProperty('--chip-swatch-text', fixedFlavor.textColor || '#ffffff');
      }
      row.appendChild(chip);
      wrapper.appendChild(row);
      return wrapper;
    }

    /* ── Render "what's in this bundle" rows, with each component's own
       flavor chip INLINE inside its row when Shopify auto-named a bundle
       option specifically for that component ("{Component title} (...)" —
       see sections/bundle-product-page.liquid for the same matching rule).
       Returns which option indexes were placed this way, so the leftover
       block below only renders options that aren't tied to one component. ── */
    function renderComponentRows(components, seedVariant) {
      var matchedIndexes = {};

      components.forEach(function (comp) {
        var row = document.createElement('div');
        row.className = 'bqa-component';
        /* Per-flavor thumbnail maps, consumed by the chip click handler to swap
           this row's image when its flavor changes: by option value first, then
           by position (handles bundle-vs-component flavor-name drift). */
        row._pmImages        = comp.images || null;
        row._pmImagesByIndex = comp.imagesByIndex || null;

        var mediaDiv = document.createElement('div');
        if (comp.image) {
          mediaDiv.className = 'bqa-component__media';
          var img = document.createElement('img');
          img.src     = comp.image;
          img.alt     = comp.title;
          img.width   = 72;
          img.height  = 72;
          img.loading = 'lazy';
          mediaDiv.appendChild(img);
        } else {
          mediaDiv.className = 'bqa-component__media bqa-component__media--placeholder';
        }

        var infoDiv = document.createElement('div');
        infoDiv.className = 'bqa-component__info';

        var nameEl = document.createElement(comp.handle ? 'a' : 'p');
        nameEl.className   = 'bqa-component__name';
        nameEl.textContent = comp.title;
        if (comp.handle) nameEl.href = '/products/' + comp.handle;
        infoDiv.appendChild(nameEl);

        var prefix = comp.title + ' (';
        var matchedAny = false;
        bundleOptions.forEach(function (opt, optionIndex) {
          if (opt.name.indexOf(prefix) === 0) {
            matchedIndexes[optionIndex] = true;
            matchedAny = true;
            infoDiv.appendChild(buildOptionChips(opt, optionIndex, seedVariant, true));
          }
        });

        /* No bundle-level selector for this component (single flavor value,
           nothing to choose) — show the fixed value so it's still visible. */
        if (!matchedAny && comp.fixedFlavor) {
          infoDiv.appendChild(buildFixedFlavorBadge(comp.fixedFlavor));
        }

        row.appendChild(mediaDiv);
        row.appendChild(infoDiv);
        bodyEl.appendChild(row);
      });

      return matchedIndexes;
    }

    /* ── Render any bundle option NOT tied to a single component (Shopify
       combined matching option values into one shared selector) in a
       general block after the component list. ── */
    function renderVariantChips(seedVariant, matchedIndexes) {
      if (!bundleOptions.length || bundleVariants.length <= 1) return;

      var container = document.createElement('div');
      var wroteAny  = false;

      bundleOptions.forEach(function (opt, optionIndex) {
        if (matchedIndexes[optionIndex]) return;
        if (!container.className) container.className = 'bqa-variants';
        container.appendChild(buildOptionChips(opt, optionIndex, seedVariant, false));
        wroteAny = true;
      });

      if (wroteAny) bodyEl.appendChild(container);
    }

    /* ── Resolve the real bundle variant matching selectedOptions, and update
       price / ATC / Buy Now / qty max / header image accordingly. Mirrors
       sections/product.liquid's updateVariant(). ── */
    function updateVariant() {
      if (!bundleVariants.length) return;

      var indices = Object.keys(selectedOptions).sort();
      var matched = null;
      for (var i = 0; i < bundleVariants.length; i++) {
        var v    = bundleVariants[i];
        var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null; });
        var match = indices.every(function (idx) {
          return opts[parseInt(idx, 10)] === selectedOptions[idx];
        });
        if (match) { matched = v; break; }
      }
      if (!matched) return;

      currentVariantId = matched.id;

      if (priceEl) priceEl.textContent = formatMoney(matched.price);

      var atcText = atcBtn ? atcBtn.querySelector('.ui-atc-btn__text') : null;
      var buyText = buyBtn ? buyBtn.querySelector('.ui-buy-btn__text') : null;
      if (atcBtn) {
        atcBtn.disabled = !matched.available;
        if (atcText) atcText.textContent = matched.available ? atcOriginalLabel : labelSoldOut;
      }
      if (buyBtn) {
        buyBtn.disabled = !matched.available;
        if (buyText) buyText.textContent = matched.available ? buyOriginalLabel : labelSoldOut;
      }

      if (qtyInput && window.Pushmax) {
        window.Pushmax.applyQtyMax(qtyInput, window.Pushmax.getMaxQty(
          matched.inventory_management || '',
          matched.inventory_policy    || '',
          matched.inventory_quantity  || 0
        ));
      }

      /* Header image follows the selected flavor when it has its own image */
      if (matched.featured_image && matched.featured_image.src && mediaEl) {
        var headerImg = mediaEl.querySelector('img');
        if (headerImg) {
          headerImg.src = matched.featured_image.src;
          headerImg.alt = matched.featured_image.alt || headerImg.alt;
        }
      }
    }

    /* ── Chip clicks — delegated on the stable #bqa-body element, since its
       contents are rebuilt on every drawer open. Matches chips wherever they
       land: inline inside a component row, or in the general .bqa-variants
       fallback block. ── */
    bodyEl.addEventListener('click', function (e) {
      var chip = e.target.closest('.ui-chips__chip');
      if (!chip || chip.classList.contains('ui-chips__chip--unavailable')) return;

      var optionIndex = chip.dataset.optionIndex;
      var chipValue   = chip.dataset.chipValue;

      chip.closest('.ui-chips__row').querySelectorAll('.ui-chips__chip').forEach(function (c) {
        var isActive = c.dataset.chipValue === chipValue;
        c.classList.toggle('ui-chips__chip--active', isActive);
        c.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      var chipWrapper = chip.closest('.ui-chips');
      if (chipWrapper) {
        var selectedValEl = chipWrapper.querySelector('.ui-chips__selected-val');
        if (selectedValEl) selectedValEl.textContent = ': ' + chipValue;
      }

      /* If this chip belongs to a component row, swap that component's thumbnail
         to the selected flavor's native variant image (when one is mapped).
         Match by option-value name first, then fall back to position — the
         bundle option value can differ in text from the component's own variant
         name (e.g. "Blueberry Razz" vs "Blue Raspberry"). */
      var compRow = chip.closest('.bqa-component');
      if (compRow) {
        var newSrc = compRow._pmImages ? compRow._pmImages[chipValue] : null;
        if (!newSrc && compRow._pmImagesByIndex) {
          var valIndex = parseInt(chip.dataset.valueIndex, 10);
          if (!isNaN(valIndex)) newSrc = compRow._pmImagesByIndex[valIndex];
        }
        if (newSrc) {
          var mediaDiv = compRow.querySelector('.bqa-component__media');
          var compImg  = mediaDiv ? mediaDiv.querySelector('img') : null;
          if (compImg) {
            compImg.src = newSrc;
          } else if (mediaDiv) {
            /* Component had no default image (placeholder) — inject one now. */
            mediaDiv.className = 'bqa-component__media';
            compImg = document.createElement('img');
            compImg.src     = newSrc;
            compImg.width    = 72;
            compImg.height   = 72;
            compImg.loading  = 'lazy';
            mediaDiv.appendChild(compImg);
          }
        }
      }

      selectedOptions[optionIndex] = chipValue;
      updateVariant();
    });

    /* ── Cart add — delegates to window.addToCart (global-header.liquid).
       No line-item properties needed: currentVariantId IS the correct real
       variant, so Shopify's own order/fulfillment view already shows the
       right components via the Bundles app's Function. ── */
    function cartAdd(onSuccess, onError) {
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      window.addToCart(currentVariantId, onSuccess, onError, qty);
    }

    /* ── Event: open drawer on Quick Add click ── */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bundle-quick-add]');
      if (!btn) return;

      var components = [];
      try { components = JSON.parse(btn.dataset.bundleComponents || '[]'); } catch (err) {}

      bundleVariants = [];
      try { bundleVariants = JSON.parse(btn.dataset.bundleVariants || '[]'); } catch (err) {}

      bundleOptions = [];
      try { bundleOptions = JSON.parse(btn.dataset.bundleOptions || '[]'); } catch (err) {}

      /* Parse swatch map: "Cherry|#FF0000|#ffffff,Lemon|#FFFF00|#141414" */
      swatchMap = {};
      if (btn.dataset.swatchMap) {
        btn.dataset.swatchMap.split(',').forEach(function (pair) {
          var parts = pair.split('|');
          if (parts.length === 3) swatchMap[parts[0]] = { color: parts[1], text: parts[2] };
        });
      }

      currentVariantId = parseInt(btn.dataset.variantId, 10) || null;
      selectedOptions  = {};

      var seedVariant = null;
      bundleVariants.forEach(function (v) { if (v.id === currentVariantId) seedVariant = v; });

      /* Populate header */
      if (titleEl) titleEl.textContent = btn.dataset.productTitle || '';
      if (priceEl) {
        priceEl.textContent = formatMoney(seedVariant ? seedVariant.price : (parseInt(btn.dataset.productPrice, 10) || 0));
      }

      /* Header image */
      if (mediaEl) {
        mediaEl.innerHTML = '';
        var imgSrc = btn.dataset.productImage;
        if (imgSrc) {
          var headerImg = document.createElement('img');
          headerImg.src       = imgSrc;
          headerImg.alt       = btn.dataset.productTitle || '';
          headerImg.width     = 72;
          headerImg.height    = 72;
          headerImg.className = 'bqa-drawer__header-img';
          mediaEl.appendChild(headerImg);
        }
      }

      /* Reset UI */
      resetAtcBtn();
      resetBuyBtn();
      resetQty();

      /* Render body: component rows first (with each component's own flavor
         chip inline, when Shopify tied one to it), then any leftover option
         that isn't tied to a single component. */
      bodyEl.innerHTML = '';
      var matchedIndexes = renderComponentRows(components, seedVariant);
      renderVariantChips(seedVariant, matchedIndexes);

      /* Apply ATC/Buy Now/qty state for the seeded variant */
      if (bundleVariants.length) updateVariant();

      openDrawer();
    });

    /* ── Event: close ── */
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    /* ── Event: ATC ── */
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled || !currentVariantId) return;
        var textEl = atcBtn.querySelector('.ui-atc-btn__text');
        atcBtn.classList.add('ui-atc-btn--loading');
        atcBtn.disabled = true;
        cartAdd(
          function () {
            /* success */
            atcBtn.classList.remove('ui-atc-btn--loading');
            atcBtn.classList.add('ui-atc-btn--added');
            if (textEl) textEl.textContent = labelAdded;
            if (window.announceA11y) window.announceA11y(labelAddedAnnounce);
            if (window.openCartDrawer) window.openCartDrawer();
            closeDrawer();
            setTimeout(resetAtcBtn, 1200);
          },
          function () {
            /* error */
            atcBtn.classList.remove('ui-atc-btn--loading');
            atcBtn.disabled = false;
            if (textEl) {
              textEl.textContent = labelError;
              setTimeout(function () { if (textEl) textEl.textContent = atcOriginalLabel; }, 2000);
            }
          }
        );
      });
    }

    /* ── Event: Buy Now ── */
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        if (buyBtn.disabled || !currentVariantId) return;
        var textEl = buyBtn.querySelector('.ui-buy-btn__text');
        buyBtn.classList.add('ui-buy-btn--loading');
        buyBtn.disabled = true;
        if (textEl) textEl.textContent = labelProcessing;
        cartAdd(
          function () {
            window.location.href = '/checkout';
          },
          function () {
            buyBtn.classList.remove('ui-buy-btn--loading');
            buyBtn.disabled = false;
            if (textEl) {
              textEl.textContent = labelError;
              setTimeout(function () { if (textEl) textEl.textContent = buyOriginalLabel; }, 2000);
            }
          }
        );
      });
    }

    /* ── bfcache reset (browser back from checkout) ── */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      closeDrawer();
      resetAtcBtn();
      resetBuyBtn();
      resetQty();
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var cartTrigger = document.getElementById('cart-drawer-trigger');
    var cartDrawer  = document.getElementById('cart-drawer');
    var cartOverlay = document.getElementById('cart-drawer-overlay');
    var cartClose   = document.getElementById('cart-drawer-close');
    var cartBody    = document.getElementById('cart-drawer-body');
    var cartFooter  = document.getElementById('cart-drawer-footer');
    var cartSubtotal = document.getElementById('cart-drawer-subtotal');

    if (!cartDrawer) return;

    var emptyMessage   = cartDrawer.dataset.emptyMessage || "Looks like your cart skipped leg day.";
    var moneyFormat    = cartDrawer.dataset.moneyFormat  || '$0.00';
    var labelShopLink  = cartDrawer.dataset.labelShopLink     || 'Shop Supplements &amp; Bundles';
    var labelDecrease  = cartDrawer.dataset.labelDecrease     || 'Decrease quantity';
    var labelIncrease  = cartDrawer.dataset.labelIncrease     || 'Increase quantity';
    var labelRemove    = cartDrawer.dataset.labelRemove       || 'Remove item';
    var labelCouldNotLoad = cartDrawer.dataset.labelCouldNotLoad || 'Could not load cart.';

    /* ── Money formatter — logic shared via window.Pushmax (snippets/theme-utils) ── */
    function formatMoney(cents) {
      return window.Pushmax.formatMoney(cents, moneyFormat);
    }

    /* ── HTML escape — prevents XSS in innerHTML string building (shared via window.Pushmax) ── */
    function escapeHTML(str) {
      return window.Pushmax.escapeHTML(str);
    }

    /* ── Cart count badge — lives on the header's cart trigger button ── */
    function updateCartCountBadge(count) {
      var badge = document.querySelector('.global-header__cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'global-header__cart-count';
          badge.setAttribute('aria-hidden', 'true');
          if (cartTrigger) cartTrigger.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
      if (window.announceA11y) {
        window.announceA11y(
          count > 0
            ? count + ' item' + (count !== 1 ? 's' : '') + ' in your cart'
            : 'Cart is empty'
        );
      }
    }

    /* ── Cart render ── */
    function renderCart(cart) {
      updateCartCountBadge(cart.item_count);

      if (cart.item_count === 0) {
        cartBody.innerHTML =
          '<div class="cart-drawer__empty">' +
            '<p class="cart-drawer__empty-message">' + emptyMessage + '</p>' +
            '<a href="/pages/supplements-and-bundles" class="cart-drawer__empty-link">' + labelShopLink + '</a>' +
          '</div>';
        if (cartFooter) cartFooter.style.display = 'none';
        return;
      }

      var itemsHtml = '';
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<p class="cart-drawer__item-variant">' + escapeHTML(item.variant_title) + '</p>' : '';
        var imageHtml = item.image
          ? '<img src="' + escapeHTML(item.image) + '" alt="' + escapeHTML(item.product_title) + '" class="cart-drawer__item-image" width="80" height="80" loading="lazy">'
          : '<div class="cart-drawer__item-image-placeholder"></div>';

        itemsHtml +=
          '<div class="cart-drawer__item">' +
            '<a href="' + escapeHTML(item.url) + '" class="cart-drawer__item-image-link">' + imageHtml + '</a>' +
            '<div class="cart-drawer__item-details">' +
              '<a href="' + escapeHTML(item.url) + '" class="cart-drawer__item-title">' + escapeHTML(item.product_title) + '</a>' +
              variantHtml +
              '<div class="cart-drawer__item-bottom">' +
                '<div class="cart-drawer__qty ui-qty">' +
                  '<button class="ui-qty__btn" type="button" data-key="' + item.key + '" data-cart-qty="' + (item.quantity - 1) + '" aria-label="' + labelDecrease + '"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/></svg></button>' +
                  '<span class="ui-qty__value">' + item.quantity + '</span>' +
                  '<button class="ui-qty__btn" type="button" data-key="' + item.key + '" data-cart-qty="' + (item.quantity + 1) + '" aria-label="' + labelIncrease + '"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>' +
                '</div>' +
                '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>' +
              '</div>' +
            '</div>' +
            '<button class="cart-drawer__item-remove" data-key="' + item.key + '" aria-label="' + labelRemove + '">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
            '</button>' +
          '</div>';
      }

      cartBody.innerHTML = '<div class="cart-drawer__items">' + itemsHtml + '</div>';
      if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.items_subtotal_price);
      if (cartFooter) cartFooter.style.display = '';
    }

    function cartSkeletonHTML() {
      var item =
        '<div class="cart-skeleton__item">' +
          '<div class="skeleton cart-skeleton__img"></div>' +
          '<div class="cart-skeleton__lines">' +
            '<div class="skeleton cart-skeleton__line" style="width:68%"></div>' +
            '<div class="skeleton cart-skeleton__line" style="width:44%"></div>' +
            '<div class="skeleton cart-skeleton__line" style="width:28%"></div>' +
          '</div>' +
        '</div>';
      return '<div class="cart-skeleton">' + item + item + item + '</div>';
    }

    function fetchAndRenderCart() {
      if (!cartBody) return;
      cartBody.innerHTML = cartSkeletonHTML();
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(renderCart)
        .catch(function () {
          cartBody.innerHTML = '<p style="padding:24px;color:#888;font-size:.875rem;">' + labelCouldNotLoad + '</p>';
        });
    }

    /* ── Cart drawer open/close ── */
    var _cartLastFocus = null;

    function openCartDrawer() {
      if (!cartDrawer) return;
      /* Close the nav drawer if it's open — guarded since it lives in
         sections/global-header.liquid, a different section/script scope. */
      if (window.closeNavDrawer) window.closeNavDrawer();
      _cartLastFocus = document.activeElement;
      cartDrawer.classList.add('is-open');
      cartOverlay.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');
      if (cartTrigger) cartTrigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      fetchAndRenderCart();
      /* Trap after content renders */
      setTimeout(function () { if (window.trapFocus) window.trapFocus(cartDrawer); }, 150);
    }

    function closeCartDrawer() {
      if (!cartDrawer) return;
      if (window.releaseFocus) window.releaseFocus(cartDrawer);
      cartDrawer.classList.remove('is-open');
      cartOverlay.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      if (cartTrigger) cartTrigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (_cartLastFocus) { _cartLastFocus.focus(); _cartLastFocus = null; }
    }

    if (cartTrigger) cartTrigger.addEventListener('click', openCartDrawer);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
    if (cartClose) cartClose.addEventListener('click', closeCartDrawer);

    /* ── Quantity / remove in cart body ── */
    if (cartBody) {
      cartBody.addEventListener('click', function (e) {
        var qtyBtn = e.target.closest('.ui-qty__btn[data-cart-qty]');
        if (qtyBtn) {
          var key = qtyBtn.dataset.key;
          var qty = parseInt(qtyBtn.dataset.cartQty, 10);
          cartBody.innerHTML = '<div class="cart-drawer__loading"><div class="cart-drawer__spinner"></div></div>';
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty })
          })
          .then(function (res) { return res.json(); })
          .then(renderCart)
          .catch(fetchAndRenderCart);
          return;
        }

        var removeBtn = e.target.closest('.cart-drawer__item-remove');
        if (removeBtn) {
          cartBody.innerHTML = '<div class="cart-drawer__loading"><div class="cart-drawer__spinner"></div></div>';
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: removeBtn.dataset.key, quantity: 0 })
          })
          .then(function (res) { return res.json(); })
          .then(renderCart)
          .catch(fetchAndRenderCart);
        }
      });
    }

    /* ── Escape key closes the cart drawer if it's open ── */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (cartDrawer.classList.contains('is-open')) closeCartDrawer();
    });

    /* ── Global helpers for other sections ── */
    window.openCartDrawer  = openCartDrawer;
    window.closeCartDrawer = closeCartDrawer;
    window.updateCartCount = updateCartCountBadge;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var itemsEl = document.getElementById('cart-page-items');
    var subtotalEl = document.getElementById('cart-page-subtotal');
    var totalEl = document.getElementById('cart-page-total');
    var moneyFormat = (itemsEl && itemsEl.dataset.moneyFormat) || '$0.00';

    /* Money formatter — logic shared via window.Pushmax (snippets/theme-utils) */
    function formatMoney(cents) {
      return window.Pushmax.formatMoney(cents, moneyFormat);
    }

    function setLoading(on) {
      if (itemsEl) itemsEl.classList.toggle('cart-page__items--loading', on);
    }

    function updateItem(key, qty) {
      setLoading(true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart.item_count === 0) {
          window.location.reload();
          return;
        }
        updateSummary(cart);
        updateItemRow(key, qty, cart);
        setLoading(false);
        if (window.updateCartCount) window.updateCartCount(cart.item_count);
      })
      .catch(function () { window.location.reload(); });
    }

    function updateSummary(cart) {
      var subtotal = formatMoney(cart.items_subtotal_price);
      if (subtotalEl) subtotalEl.textContent = subtotal;
      if (totalEl) totalEl.textContent = subtotal;
    }

    function updateItemRow(key, qty, cart) {
      var row = document.querySelector('.cart-page__item[data-key="' + key + '"]');
      if (!row) return;

      if (qty === 0) {
        row.remove();
        return;
      }

      var item = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === key) { item = cart.items[i]; break; }
      }
      if (!item) { row.remove(); return; }

      var qtyVal = row.querySelector('.ui-qty__value');
      var linePrice = row.querySelector('.cart-page__item-line-price');
      var decBtn = row.querySelector('.ui-qty__btn[data-cart-qty]');
      var incBtn = row.querySelectorAll('.ui-qty__btn[data-cart-qty]')[1];

      if (qtyVal) qtyVal.textContent = item.quantity;
      if (linePrice) linePrice.textContent = formatMoney(item.final_line_price);
      if (decBtn) decBtn.dataset.cartQty = item.quantity - 1;
      if (incBtn) incBtn.dataset.cartQty = item.quantity + 1;
    }

    if (itemsEl) {
      itemsEl.addEventListener('click', function (e) {
        var qtyBtn = e.target.closest('.ui-qty__btn[data-cart-qty]');
        if (qtyBtn) {
          var key = qtyBtn.dataset.key;
          var qty = parseInt(qtyBtn.dataset.cartQty, 10);
          if (qty < 0) qty = 0;
          updateItem(key, qty);
          return;
        }

        var removeBtn = e.target.closest('.cart-page__item-remove');
        if (removeBtn) {
          updateItem(removeBtn.dataset.key, 0);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-header"]) return;
  try {
    
  (function () {
    /* ── Nav drawer ── */
    var header = document.getElementById('global-header');
    var hamburger = document.getElementById('global-header-hamburger');
    var navDrawer = document.getElementById('nav-drawer');
    var navOverlay = document.getElementById('nav-drawer-overlay');
    var navClose = document.getElementById('nav-drawer-close');

    /* ── Header hide on scroll ── */
    if (header) {
      var lastScrollY = window.scrollY;
      var ticking = false;
      function updateHeader() {
        var currentScrollY = window.scrollY;
        if (currentScrollY > lastScrollY && currentScrollY > header.offsetHeight) {
          header.classList.add('global-header--hidden');
        } else {
          header.classList.remove('global-header--hidden');
        }
        header.classList.toggle('global-header--scrolled', currentScrollY > 80);
        lastScrollY = currentScrollY;
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { requestAnimationFrame(updateHeader); ticking = true; }
      }, { passive: true });
      /* Apply scrolled state immediately if page loads mid-scroll */
      updateHeader();
    }

    /* ── Nav drawer open/close ── */
    var _navLastFocus = null;

    function openNavDrawer() {
      /* Close the cart drawer if it's open — guarded since it lives in
         sections/cart-drawer.liquid, a different section/script scope. */
      if (window.closeCartDrawer) window.closeCartDrawer();
      _navLastFocus = document.activeElement;
      navDrawer.classList.add('is-open');
      navOverlay.classList.add('is-open');
      navDrawer.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (window.trapFocus) window.trapFocus(navDrawer);
    }

    function closeNavDrawer() {
      if (window.releaseFocus) window.releaseFocus(navDrawer);
      if (navDrawer) { navDrawer.classList.remove('is-open'); navDrawer.setAttribute('aria-hidden', 'true'); }
      if (navOverlay) navOverlay.classList.remove('is-open');
      if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (_navLastFocus) { _navLastFocus.focus(); _navLastFocus = null; }
    }

    if (hamburger) hamburger.addEventListener('click', openNavDrawer);
    if (navOverlay) navOverlay.addEventListener('click', closeNavDrawer);
    if (navClose) navClose.addEventListener('click', closeNavDrawer);

    /* ── Accordion ── */
    document.querySelectorAll('.nav-drawer__accordion-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        var content = document.getElementById(btn.getAttribute('aria-controls'));
        btn.setAttribute('aria-expanded', !isOpen);
        content.setAttribute('aria-hidden', isOpen);
        content.classList.toggle('is-open', !isOpen);
      });
    });

    /* ── Escape key closes the nav drawer if it's open ── */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (navDrawer && navDrawer.classList.contains('is-open')) closeNavDrawer();
    });

    /* ── Global helper for cart-drawer.liquid (closes nav before opening cart) ── */
    window.closeNavDrawer = closeNavDrawer;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {

    /* Product gallery + variant + add-to-cart logic. The image lightbox is a
       separate shared component (snippets/image-lightbox.liquid), wired via
       data-lightbox-* attributes on the gallery markup. */

    /* ── Variant data — loaded from data-variants attribute ── */
    var variants = null;
    var selectedOptions = {}; /* keyed by option index (0-based) */

    var optionsEl = document.querySelector('.product-page__options');
    if (optionsEl && optionsEl.dataset.variants) {
      variants = JSON.parse(optionsEl.dataset.variants);
      /* Seed selected options from active chip state */
      optionsEl.querySelectorAll('.ui-chips__chip--active').forEach(function (chip) {
        selectedOptions[chip.dataset.optionIndex] = chip.dataset.chipValue;
      });
    }

    /* ── DOM refs ── */
    var atcBtn    = document.getElementById('product-atc-btn');
    var buyBtn    = document.getElementById('product-buy-btn');
    var atcTextEl = atcBtn ? atcBtn.querySelector('.ui-atc-btn__text') : null;
    var buyTextEl = buyBtn ? buyBtn.querySelector('.ui-buy-btn__text') : null;

    var actionsEl        = document.querySelector('.product-page__actions');
    var atcOriginalLabel = atcBtn ? (atcBtn.dataset.label || 'Add to cart') : 'Add to cart';
    var buyOriginalLabel = buyBtn ? (buyBtn.dataset.label || 'Buy now')      : 'Buy now';
    var labelAdded       = actionsEl ? (actionsEl.dataset.labelAdded      || 'Added!')           : 'Added!';
    var labelSoldOut     = actionsEl ? (actionsEl.dataset.labelSoldOut    || 'Sold out')         : 'Sold out';
    var labelError       = actionsEl ? (actionsEl.dataset.labelError      || 'Error — try again'): 'Error — try again';
    var labelProcessing  = actionsEl ? (actionsEl.dataset.labelProcessing || 'Processing...')    : 'Processing...';

    var qtyInput = document.getElementById('product-qty');
    var qtyRowEl = document.querySelector('.product-page__qty-row');

    /* ── Qty helpers — logic shared via window.Pushmax (snippets/theme-utils) ── */
    function getMaxQty(invQty, invMgmt, invPolicy) {
      return window.Pushmax.getMaxQty(invMgmt, invPolicy, invQty);
    }

    function applyQtyMax(maxQty) {
      window.Pushmax.applyQtyMax(qtyInput, maxQty);
    }

    /* Apply initial qty max from Liquid-rendered inventory data.
       IMPORTANT: window.Pushmax is defined in the SNIPPET JS bundle
       (snippets/theme-utils), which Shopify loads AFTER this SECTION bundle.
       Calling it synchronously here throws "Pushmax is undefined" and kills
       the entire section script — taking down the gallery, modal, and variant
       handlers with it. Defer until DOMContentLoaded (fires after both deferred
       bundles have executed), and guard so a missing Pushmax degrades quietly. */
    function pmInitQtyMax() {
      if (!qtyRowEl || !window.Pushmax) return;
      applyQtyMax(getMaxQty(
        parseInt(qtyRowEl.dataset.inventoryQuantity, 10) || 0,
        qtyRowEl.dataset.inventoryManagement || '',
        qtyRowEl.dataset.inventoryPolicy    || ''
      ));
    }
    if (window.Pushmax) {
      pmInitQtyMax();
    } else {
      document.addEventListener('DOMContentLoaded', pmInitQtyMax);
    }

    /* ── ATC handler — delegates to window.addToCart (global-header.liquid) ── */
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled) return;
        var variantId = parseInt(atcBtn.dataset.variantId, 10);
        if (!variantId) return;

        atcBtn.disabled = true;
        if (buyBtn) buyBtn.disabled = true;
        atcBtn.classList.add('ui-atc-btn--loading');

        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        window.addToCart(
          variantId,
          function () {
            /* Success — cart count refreshed by window.addToCart */
            atcBtn.classList.remove('ui-atc-btn--loading');
            if (atcTextEl) atcTextEl.textContent = labelAdded;
            if (window.openCartDrawer) window.openCartDrawer();
            setTimeout(function () {
              atcBtn.disabled = false;
              if (buyBtn) buyBtn.disabled = false;
              if (atcTextEl) atcTextEl.textContent = atcOriginalLabel;
            }, 1500);
          },
          function () {
            /* Error */
            atcBtn.classList.remove('ui-atc-btn--loading');
            if (atcTextEl) atcTextEl.textContent = labelError;
            atcBtn.disabled = false;
            if (buyBtn) buyBtn.disabled = false;
            setTimeout(function () {
              if (atcTextEl) atcTextEl.textContent = atcOriginalLabel;
            }, 2000);
          },
          qty
        );
      });
    }

    /* ── Thumbnail gallery — direct listeners on each button ── */
    var allThumbs = document.querySelectorAll('.product-page__thumb');
    allThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mainImg = document.getElementById('product-main-image');
        if (mainImg) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = thumb.dataset.imageUrl;
          mainImg.alt = thumb.dataset.imageAlt;
        }
        allThumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* ── Per-variant gallery grouping (opt-in via custom.variant_media) ──
       #pm-variant-media maps variant id -> allowed image filenames. Variants
       absent from the map (the common case) show every image, unchanged. ── */
    var variantMediaMap = {};
    var variantMediaEl = document.getElementById('pm-variant-media');
    if (variantMediaEl) {
      try { variantMediaMap = JSON.parse(variantMediaEl.textContent) || {}; } catch (e) { variantMediaMap = {}; }
    }

    function applyGalleryGrouping(variantId) {
      var allowedFilenames = variantMediaMap[variantId];

      if (!allowedFilenames || !allowedFilenames.length) {
        /* No grouping for this variant — show every image, leave main image as-is. */
        allThumbs.forEach(function (t) { t.style.display = ''; });
        if (window.updateLightboxImages) window.updateLightboxImages([]);
        return;
      }

      var allowedSet = {};
      allowedFilenames.forEach(function (f) { allowedSet[f] = true; });

      var firstVisibleThumb = null;
      var activeIsVisible   = false;
      allThumbs.forEach(function (t) {
        var visible = !!allowedSet[t.dataset.imageFilename];
        t.style.display = visible ? '' : 'none';
        if (visible && !firstVisibleThumb) firstVisibleThumb = t;
        if (visible && t.classList.contains('is-active')) activeIsVisible = true;
      });

      /* If the currently-shown image isn't in this variant's group, swap to
         the first grouped image (same clearing steps as a manual thumb click). */
      if (!activeIsVisible && firstVisibleThumb) {
        var mainImg = document.getElementById('product-main-image');
        if (mainImg) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = firstVisibleThumb.dataset.imageUrl;
          mainImg.alt = firstVisibleThumb.dataset.imageAlt;
        }
        allThumbs.forEach(function (t) { t.classList.remove('is-active'); });
        firstVisibleThumb.classList.add('is-active');
      }

      /* Keep the lightbox's image set (and thumbnail strip) in sync */
      if (window.getLightboxImages && window.updateLightboxImages) {
        var filtered = window.getLightboxImages().filter(function (im) {
          return allowedSet[im.filename];
        });
        window.updateLightboxImages(filtered);
      }
    }

    /* ── Delegated click handler — variant chip + Buy Now ── */
    document.addEventListener('click', function (e) {

      /* Variant chip (from ui-variant-chips sub-component) */
      var chip = e.target.closest('.ui-chips__chip');
      if (chip && !chip.classList.contains('ui-chips__chip--unavailable') && optionsEl && optionsEl.contains(chip)) {
        var optionIndex = chip.dataset.optionIndex;
        var chipValue   = chip.dataset.chipValue;

        /* Update active chip state within this option group */
        var row = chip.closest('.ui-chips__row');
        if (row) {
          row.querySelectorAll('.ui-chips__chip').forEach(function (c) {
            c.classList.toggle('ui-chips__chip--active', c === chip);
            c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
          });
        }

        /* Update selected-value label display */
        var chipWrapper = chip.closest('.ui-chips');
        if (chipWrapper) {
          var selectedValEl = chipWrapper.querySelector('.ui-chips__selected-val');
          if (selectedValEl) selectedValEl.textContent = ': ' + chipValue;
        }

        selectedOptions[optionIndex] = chipValue;
        updateVariant();
        return;
      }

      /* Buy Now */
      var buyNowBtn = e.target.closest('[data-action="product-buy"]');
      if (buyNowBtn) {
        var variantId = parseInt(buyNowBtn.dataset.variantId, 10);
        if (!variantId) return;
        var bTextEl = buyNowBtn.querySelector('.ui-buy-btn__text');
        if (bTextEl) bTextEl.textContent = labelProcessing;
        buyNowBtn.disabled = true;
        if (atcBtn) atcBtn.disabled = true;

        var buyQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        /* Use shared window.addToCart for Buy Now (still maintained in global-header) */
        window.addToCart(
          variantId,
          function () {
            window.location.href = '/checkout';
          },
          function () {
            if (bTextEl) bTextEl.textContent = labelError;
            buyNowBtn.disabled = false;
            if (atcBtn) atcBtn.disabled = false;
            setTimeout(function () {
              if (bTextEl) bTextEl.textContent = buyOriginalLabel;
            }, 2000);
          },
          buyQty
        );
      }
    });

    /* ── bfcache reset (browser back from checkout) ── */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      if (buyTextEl) buyTextEl.textContent = buyOriginalLabel;
      if (buyBtn) buyBtn.disabled = false;
      if (atcBtn) {
        atcBtn.disabled = false;
        atcBtn.classList.remove('ui-atc-btn--loading');
      }
      if (atcTextEl) atcTextEl.textContent = atcOriginalLabel;
    });

    /* ── Update variant state after option change ── */
    function updateVariant() {
      if (!variants) return;

      var indices = Object.keys(selectedOptions).sort();
      var matched = null;

      for (var i = 0; i < variants.length; i++) {
        var v    = variants[i];
        var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null; });
        var match = indices.every(function (idx) {
          return opts[parseInt(idx, 10)] === selectedOptions[idx];
        });
        if (match) { matched = v; break; }
      }

      if (!matched) return;

      /* Price */
      var priceEl = document.getElementById('product-price');
      if (priceEl) priceEl.textContent = '$' + (matched.price / 100).toFixed(2);

      /* Keep subscription form variant input in sync */
      var variantInput = document.getElementById('product-variant-input');
      if (variantInput) variantInput.value = matched.id;

      /* ATC button */
      if (atcBtn) {
        atcBtn.dataset.variantId = matched.id;
        if (matched.available) {
          atcBtn.disabled = false;
          atcBtn.classList.remove('ui-atc-btn--soldout');
          if (atcTextEl) atcTextEl.textContent = atcOriginalLabel;
        } else {
          atcBtn.disabled = true;
          atcBtn.classList.add('ui-atc-btn--soldout');
          if (atcTextEl) atcTextEl.textContent = labelSoldOut;
        }
      }

      /* Buy Now button */
      if (buyBtn) {
        buyBtn.dataset.variantId = matched.id;
        buyBtn.disabled = !matched.available;
        if (buyTextEl) buyTextEl.textContent = matched.available ? buyOriginalLabel : labelSoldOut;
      }

      /* Qty max — inventory-aware, capped at 50 */
      applyQtyMax(getMaxQty(
        matched.inventory_quantity || 0,
        matched.inventory_management || '',
        matched.inventory_policy    || ''
      ));

      /* Variant image swap — clear srcset/sizes first, otherwise the browser
         may keep resolving one of the responsive candidates from the initial
         featured image instead of showing the variant's own image. */
      if (matched.featured_image && matched.featured_image.src) {
        var mainImg = document.getElementById('product-main-image');
        if (mainImg) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = matched.featured_image.src;
          mainImg.alt = matched.featured_image.alt || mainImg.alt;
        }
      }

      /* Per-variant gallery grouping — filters thumbnails + lightbox to this
         variant's images when custom.variant_media is set (see FLAVOR_AND_VARIANT_MEDIA.md) */
      applyGalleryGrouping(matched.id);
    }


  })();

  } catch(e) { console.error(e); }
})();
})();
